// removed by extract-text-webpack-plugin
module.exports = {"container":"_7bFh8kF1yB3n_8ShOXNo2","content":"_92QikhyWd39FQ4S0S0Vw8","edit":"_2COtV4JDon7HrZTJ84shWj","loading":"_1nn0r1ZG7BXOwDDC2j8_kX","loader":"wPI8xhIa3gnm2CKHASmTF","load8":"_2nm4Z_XsJOJYEd8R_zFdHo","modalContent":"_2FerNfc006N0falKDGNbi9"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ItemList/ItemList.scss
 ** module id = 737
 ** module chunks = 0
 **/